import { Loader2, PackageOpen } from "lucide-react";
import { AppCard } from "@/components/apps/AppCard";
import { useI18n } from "@/i18n/I18nContext";

export const AppGrid = ({ apps, error }) => {
  const { t } = useI18n();
  if (apps === null) {
    return (
      <div className="flex items-center gap-3 py-12 text-neutral-400" data-testid="apps-loading">
        <Loader2 className="h-5 w-5 animate-spin text-[var(--gold)]" /> {t("apps.loading")}
      </div>
    );
  }
  if (!apps.length) {
    return (
      <div className="card-carbon flex items-center gap-4 rounded-2xl p-8 text-neutral-300" data-testid="apps-empty">
        <PackageOpen className="h-8 w-8 shrink-0 text-[var(--gold)]" />
        {error ? t("apps.error") : t("apps.empty")}
      </div>
    );
  }
  return (
    <div className="grid items-start gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="apps-grid">
      {apps.map((app, i) => (
        <AppCard key={app.id} app={app} index={i} />
      ))}
    </div>
  );
};
